import { UnitType } from "@src/core/api/unitsPreferences";

export type PhysicalType = CombinedPhysicalType | SinglePhysicalType;

export type SinglePhysicalType =
  | "PHYS_AREA"
  | "PHYS_DENSITY"
  | "PHYS_DIAMETER"
  | "PHYS_DIFFPRESS"
  | "PHYS_DIFFTEMP"
  | "PHYS_ELEC_POWER"
  | "PHYS_ENERGY"
  | "PHYS_FLOW"
  | "PHYS_FORCE"
  | "PHYS_HEATTRANSF"
  | "PHYS_KINVISC"
  | "PHYS_LENGTH"
  | "PHYS_LINDP"
  | "PHYS_MASS"
  | "PHYS_PRESSURE"
  | "PHYS_ROUGHNESS"
  | "PHYS_SPECIFHEAT"
  | "PHYS_TEMP"
  | "PHYS_TH_POWER"
  | "PHYS_THERMCOND"
  | "PHYS_THICKNESS"
  | "PHYS_TORQUE"
  | "PHYS_VALVCOEFF"
  | "PHYS_VELOCITY"
  | "PHYS_VOLUME"
  | "PHYS_WATERHARDNESS";

type CombinedPhysicalType = `${SinglePhysicalType}.${SinglePhysicalType}`;

export const physicalTypeToUnitType: Record<SinglePhysicalType, UnitType> = {
  PHYS_AREA: "area",
  PHYS_DENSITY: "density",
  PHYS_DIAMETER: "diameter",
  PHYS_DIFFPRESS: "differentialPressure",
  PHYS_DIFFTEMP: "temperatureDifference",
  PHYS_ELEC_POWER: "electricalPower",
  PHYS_ENERGY: "energy",
  PHYS_FLOW: "flow",
  PHYS_FORCE: "force",
  PHYS_HEATTRANSF: "heatTransfer",
  PHYS_KINVISC: "kinematicViscosity",
  PHYS_LENGTH: "length",
  PHYS_LINDP: "linearPressureDrop",
  PHYS_MASS: "mass",
  PHYS_PRESSURE: "staticPressure",
  PHYS_ROUGHNESS: "roughness",
  PHYS_SPECIFHEAT: "specificHeat",
  PHYS_TEMP: "temperature",
  PHYS_TH_POWER: "thermalPower",
  PHYS_THERMCOND: "thermalConductivity",
  PHYS_THICKNESS: "thickness",
  PHYS_TORQUE: "torque",
  PHYS_VALVCOEFF: "kvCvCoefficient",
  PHYS_VELOCITY: "velocity",
  PHYS_VOLUME: "volume",
  PHYS_WATERHARDNESS: "waterHardness",
};

// Valve coefficient is a special case where it is not really a unit, but there is still a difference
// between Kv and Cv that we want to reflect in the UI, so we want to keep the physical type.
export function isInlineValueUnit(physicalType?: PhysicalType | null) {
  if (!physicalType) return false;
  return physicalType !== "PHYS_VALVCOEFF";
}

export function isPhysicalType(
  value: string,
): value is CombinedPhysicalType | SinglePhysicalType {
  return (
    !!value &&
    (Object.keys(physicalTypeToUnitType).includes(value) ||
      (value.split(".").length === 2 &&
        value
          .split(".")
          .every((part) => Object.keys(physicalTypeToUnitType).includes(part))))
  );
}
